module.exports = __webpack_public_path__ + "static/img/2.b21e95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/2.png
// module id = PViR
// module chunks = 0